(() => {
const root = document.documentElement;
root.classList.add('js');

if (!document.querySelector('.announcement-bar-section .utility-bar')) return;

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.add('announce--show');
    return;
}

document.addEventListener('DOMContentLoaded', () => {
    const delayRaw = getComputedStyle(root).getPropertyValue('--announce-reveal-delay').trim();

    const delay =
    delayRaw.endsWith('ms') ? parseFloat(delayRaw) :
    delayRaw.endsWith('s')  ? parseFloat(delayRaw) * 1000 :
    0;

    setTimeout(() => root.classList.add('announce--show'), delay);
});
})();
